import { ColumnsType } from 'antd/es/table'
import ApplicationTableActions from './actions'
import { TApplication } from '@/interfaces'
import dayjs from 'dayjs'

export interface TPostulanteInfo {
  name?: string
  firstName?: string
  lastName?: string
  documento?: string
}

export const applicationsColumns: ColumnsType<TApplication> = [
  {
    dataIndex: 'addressCity',
    title: 'Municipio',
    align: 'center',
    render: (city: string) => city?.toUpperCase(),
  },
  {
    dataIndex: 'convocatoriaName',
    title: 'Convocatoria',
    align: 'center',
    ellipsis: true,
    render: (convocatoria: string) => convocatoria?.toUpperCase(),
  },
  {
    dataIndex: 'consecutivoHogar',
    title: 'Id Hogar',
    align: 'center',
  },
  {
    dataIndex: 'typeimprovement',
    title: 'Tipo',
    align: 'center',
    render: (type: string) => type?.toUpperCase(),
  },
  {
    dataIndex: 'estadoName',
    title: 'Estado',
    align: 'center',
    render: (status: string) => status?.toUpperCase(),
  },
  {
    dataIndex: 'id',
    title: 'Radicado',
    align: 'center',
  },
  {
    dataIndex: 'enddate',
    title: 'Fecha de Finalización',
    align: 'center',
    render: (enddate) => {
      if (enddate) {
        return dayjs(enddate).format('YYYY-MM-DD')
      }

      return null
    },
  },
  {
    title: 'Jefe de Hogar',
    align: 'center',
    render: (_, application) => {
      const postulanteData = application.CPostulante as TPostulanteInfo
      return `${(postulanteData?.name || postulanteData?.firstName) ?? ''} ${postulanteData?.lastName ?? ''}`
    },
  },
  {
    dataIndex: 'CPostulante.documento',
    title: 'Identificación',
    align: 'center',
    render: (_, application) => {
      const postulanteData = application.CPostulante as TPostulanteInfo
      return postulanteData?.documento ?? ''
    },
  },
  {
    title: 'Acciones',
    fixed: 'right',
    align: 'center',
    width: '200px',
    render: (applicationInfo: TApplication) => (
      <ApplicationTableActions
        key={applicationInfo.id as number}
        rowInfo={applicationInfo}
      />
    ),
  },
]
